var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAltTextinfoJoyful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 465.26,
    height: 465.25,
    viewBox: "0 0 465.26 465.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage_Alt_Textinfo_Joyful",
    "data-name": "Manage Alt Textinfo Joyful",
    transform: "translate(-302.741 -2806.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 195.829,
    cy: 37.845,
    rx: 195.829,
    ry: 37.845,
    transform: "translate(306.241 3173.707)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_2_",
    "data-name": "search (2)",
    transform: "translate(306.241 2810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18009",
    "data-name": "Group 18009",
    transform: "translate(0 160.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12390",
    "data-name": "Path 12390",
    d: "M9.551,143.667A9.537,9.537,0,0,1,2.792,127.38L46.517,83.655a28.764,28.764,0,0,1,40.612,0l27.438,27.419,94.266-94.266a28.764,28.764,0,0,1,40.612,0l15.084,15.084a9.545,9.545,0,0,1-13.5,13.5L235.946,30.307a9.764,9.764,0,0,0-13.614,0L121.326,131.313a9.553,9.553,0,0,1-13.5,0L73.649,97.136a9.764,9.764,0,0,0-13.614,0L16.311,140.86a9.529,9.529,0,0,1-6.759,2.807Z",
    transform: "translate(0 -8.417)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18007",
    "data-name": "Group 18007",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12388",
    "data-name": "Path 12388",
    d: "M185.973,381.875H47.734A47.789,47.789,0,0,1,0,334.141V47.734A47.789,47.789,0,0,1,47.734,0H257.766A47.789,47.789,0,0,1,305.5,47.734V176.426a9.547,9.547,0,1,1-19.094,0V47.734a28.676,28.676,0,0,0-28.641-28.641H47.734A28.676,28.676,0,0,0,19.094,47.734V334.141a28.676,28.676,0,0,0,28.641,28.641H185.973a9.547,9.547,0,1,1,0,19.094Z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18008",
    "data-name": "Group 18008",
    transform: "translate(57.286 95.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12389",
    "data-name": "Path 12389",
    d: "M41.187,81.375A38.188,38.188,0,1,1,79.375,43.188,38.226,38.226,0,0,1,41.187,81.375Zm0-57.281A19.094,19.094,0,1,0,60.281,43.188,19.113,19.113,0,0,0,41.187,24.094Z",
    transform: "translate(-3 -5)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12391",
    "data-name": "Path 12391",
    d: "M257.028,242.3l-59.8-59.8A105.814,105.814,0,1,0,183.8,196.091l59.725,59.725a9.552,9.552,0,1,0,13.5-13.518ZM30.042,116.05a85.922,85.922,0,1,1,85.922,85.922A86.027,86.027,0,0,1,30.042,116.05Z",
    transform: "translate(198.439 199.646)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(253.452 282.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M197.268,225.209a4.741,4.741,0,0,0-6.7.37,52.76,52.76,0,0,1-78.3,0,4.742,4.742,0,1,0-7.066,6.327,62.243,62.243,0,0,0,92.429,0A4.746,4.746,0,0,0,197.268,225.209Z",
    transform: "translate(-89.772 -167.092)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M231.712,128A23.739,23.739,0,0,0,208,151.712a4.742,4.742,0,1,0,9.484,0,14.227,14.227,0,1,1,28.454,0,4.742,4.742,0,1,0,9.484,0A23.739,23.739,0,0,0,231.712,128Z",
    transform: "translate(-132.122 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M117.939,151.712a4.742,4.742,0,1,0,9.484,0,23.712,23.712,0,1,0-47.424,0,4.743,4.743,0,1,0,9.485,0,14.227,14.227,0,1,1,28.454,0Z",
    transform: "translate(-80 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18010",
    "data-name": "Group 18010",
    transform: "translate(349.443 3117.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 18.499,
    transform: "translate(74.509)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 29.452,
    transform: "translate(83.759)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 18.499,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 29.452,
    transform: "translate(9.249)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 14.799,
    y2: 29.452,
    transform: "translate(39.105)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 14.799,
    y2: 29.452,
    transform: "translate(39.105)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAltTextinfoJoyful);
export default __webpack_public_path__ + "static/media/manage-alt-textinfo-joyful.21f82dde0cca92cd3bd6424df3f26ad5.svg";
export { ForwardRef as ReactComponent };